import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-contact-img',
  templateUrl: './contact-img.component.html',
})

export class ContactImgComponent {
  @Input() color: string = '';
}
